import { useFormContext } from 'react-hook-form'
import { useEffect, useMemo } from 'react'
import {
  personalInformationSchema,
  addressSchema,
  passwordSchema,
  bankSchema,
  Step,
  RegisterFormData,
} from './types'

export const useStepValidation = (step: Step) => {
  const {
    watch,
    trigger,
    formState: { isDirty },
  } = useFormContext<RegisterFormData>()

  const formData = watch()

  const validators: Record<Step, () => boolean> = {
    'personal-information': () => {
      const result = personalInformationSchema.safeParse(formData.personalInfo)
      // console.log(result)
      return result.success
    },
    address: () => {
      const result = addressSchema.safeParse(formData.address)
      // alert(JSON.stringify({ result, data: formData.address }, null, 2))
      return result.success
    },
    password: () => {
      const result = passwordSchema.safeParse(formData.passwordInfo)
      // console.log(result)
      return result.success
    },
    bank: () => {
      const result = bankSchema.safeParse(formData.bankInfo)
      // console.log(result)
      return result.success
    },
    'validate-identity': () => true,
    analising: () => true,
    RegisterApproved: () => true,
    RegisterDenied: () => true,
  }

  useEffect(() => {
    if (isDirty) {
      trigger()
    }
  }, [isDirty, trigger])

  const isValid = useMemo(() => {
    return validators[step]?.() ?? false
  }, [step, formData])

  return isValid
}
